import React from 'react'

export function Progress({ value = 0, className = "", ...props }) {
  // Ensure value is between 0 and 100
  const clampedValue = Math.min(100, Math.max(0, value))
  
  return (
    <div 
      className={`w-full h-2 relative overflow-hidden ${className}`}
      {...props}
    >
      {/* Background */}
      <div className="w-full h-2 absolute bg-neutral-300 rounded-[10px]" />
      
      {/* Foreground - progress indicator */}
      <div 
        className="h-2 absolute bg-neutral-900 transition-all duration-300 ease-in-out"
        style={{ width: `${clampedValue}%` }}
      />
    </div>
  )
}